<template>
  <div id="edit-notes" v-if="payload.id">
    <label @click="$router.go(-1)" class="back">
      <figure>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </figure>
      <p>Voltar</p>
    </label>
    <section class="quantity">
      <h1><strong>Título da nota</strong> (obrigatório)</h1>
      <input :maxlength="255" type="text" placeholder="Ex: Envio de folha de pagamento" v-model="payload.title">
      <p>{{ (payload.title ?? '').length }}/255</p>
    </section>
    <section class="content-section">
      <div class="content-section__header">
        <div>
          <h1><strong>Descrição para a nota</strong> (obrigatório)</h1>
          <h2>Descreva os detalhes que você precisa guardar para lembrar depois.</h2>
        </div>
        <button v-if="hasAiModule" type="button" class="ai-toggle-button" :disabled="!payload.description || isSummarizingNote" @click="summarizeNote">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M12 3L13.7 8.3L19 10L13.7 11.7L12 17L10.3 11.7L5 10L10.3 8.3L12 3Z" fill="currentColor"/>
            <path d="M19 15L19.8 17.2L22 18L19.8 18.8L19 21L18.2 18.8L16 18L18.2 17.2L19 15Z" fill="currentColor"/>
          </svg>
          {{ isSummarizingNote ? 'Resumindo...' : 'Resumir com IA' }}
        </button>
      </div>
      <div class="ai-summary" v-if="noteSummary">
        <p>{{ noteSummary }}</p>
        <button type="button" class="ai-summary__close" @click="noteSummary = ''">Fechar</button>
      </div>
      <TextEditor :value="payload.description ?? ''" :setValue="(value: string) => payload.description = value" />
    </section>
    <section>
      <h1><strong>Vincular a um documento</strong></h1>
      <h2>Se desejar, pode vincular essa nota a um documento específico</h2>
      <MyOptions :currentValue="selectedDocuments.length ? `${selectedDocuments.length} documento(s) selecionado(s)` : 'Selecione'">
        <div class="doc-search-wrapper" @click.stop>
          <input
            type="text"
            placeholder="Pesquisar documento..."
            v-model="docSearch"
            @keydown.enter.prevent="getDocuments(1)"
          >
          <svg v-if="!docSearch" @click="getDocuments(1)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none">
            <path d="M17.5002 17.5002L13.881 13.881M13.881 13.881C14.5001 13.2619 14.9912 12.527 15.3262 11.7181C15.6612 10.9093 15.8337 10.0423 15.8337 9.16684C15.8337 8.29134 15.6612 7.42441 15.3262 6.61555C14.9912 5.80669 14.5001 5.07174 13.881 4.45267C13.2619 3.8336 12.527 3.34252 11.7181 3.00748C10.9093 2.67244 10.0423 2.5 9.16684 2.5C8.29134 2.5 7.42441 2.67244 6.61555 3.00748C5.80669 3.34252 5.07174 3.8336 4.45267 4.45267C3.2024 5.70295 2.5 7.39868 2.5 9.16684C2.5 10.935 3.2024 12.6307 4.45267 13.881C5.70295 15.1313 7.39868 15.8337 9.16684 15.8337C10.935 15.8337 12.6307 15.1313 13.881 13.881Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg v-else @click="docSearch = ''; getDocuments(1)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none">
            <path d="M4 4L16 16" stroke="#079F72" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16 4L4 16" stroke="#079F72" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <template v-if="isLoadingDocs">
          <div class="doc-skeleton" v-for="i in 5" :key="'sk-' + i"></div>
        </template>
        <template v-else>
          <div class="item" v-for="doc in documents?.data ?? []" :key="doc.id" @click.stop>
            <input
              type="checkbox"
              :id="'document-' + doc.id"
              :value="doc.id"
              :checked="selectedDocuments.some(d => d.id === doc.id)"
              @change="toggleDocument(doc, ($event.target as HTMLInputElement).checked)"
            >
            <label :for="'document-' + doc.id">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
                  <g clip-path="url(#clip0_edit_note_doc)">
                    <path d="M12.3047 2.42188C12.3047 2.63021 12.2318 2.80729 12.0859 2.95312L6.42969 8.60938L5.36719 9.67188C5.22135 9.81771 5.04427 9.89062 4.83594 9.89062C4.6276 9.89062 4.45052 9.81771 4.30469 9.67188L3.24219 8.60938L0.414062 5.78125C0.268229 5.63542 0.195312 5.45833 0.195312 5.25C0.195312 5.04167 0.268229 4.86458 0.414062 4.71875L1.47656 3.65625C1.6224 3.51042 1.79948 3.4375 2.00781 3.4375C2.21615 3.4375 2.39323 3.51042 2.53906 3.65625L4.83594 5.96094L9.96094 0.828125C10.1068 0.682292 10.2839 0.609375 10.4922 0.609375C10.7005 0.609375 10.8776 0.682292 11.0234 0.828125L12.0859 1.89062C12.2318 2.03646 12.3047 2.21354 12.3047 2.42188Z"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_edit_note_doc">
                      <rect width="12.5" height="10" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <p>#{{ doc.number }} — {{ doc.title }}</p>
            </label>
          </div>
          <p v-if="documents && !documents.data.length" class="doc-empty">Nenhum documento encontrado.</p>
        </template>
        <div class="doc-pagination" v-if="!isLoadingDocs && documents && documents.links.length > 3" @click.stop>
          <button
            v-for="(link, index) in documents.links"
            :key="index"
            :disabled="(index == 0 && !documents.prev_page_url) || (index == documents.links.length - 1 && !documents.next_page_url)"
            @click.stop="getDocuments(index != 0 && (index != documents.links.length - 1) ? parseInt(link.label) : (documents.current_page + (index ? 1 : -1)))"
            :class="{ active: link.active, passers: index == 0 || index == documents.links.length - 1 }"
          >
            <svg v-if="index == 0" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg v-else-if="index == documents.links.length - 1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <template v-else>{{ link.label }}</template>
          </button>
        </div>
      </MyOptions>
    </section>
    <section>
      <h1><strong>Data para alerta</strong> (obrigatório)</h1>
      <h2>Quando você quer ser alertado sobre essa nota?</h2>
      <label class="date-picker-label" for="event_date" @click="openDateModal()">
        <input type="text" placeholder="Selecione uma data" name="event_date" :value="formattedEventDate ?? ''" id="event_date" readonly>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M8 2V5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M16 2V5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.5 9.08984H20.5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M15.6937 13.7002H15.7027" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M15.6937 16.7002H15.7027" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.9945 13.7002H12.0035" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.9945 16.7002H12.0035" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.29529 13.7002H8.30427" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.29529 16.7002H8.30427" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </label>
    </section>
    <section class="spacing">
      <h1><strong>Status</strong> (obrigatório)</h1>
      <label class="status-toggle" for="note-status">
        <input type="checkbox" name="note-status" id="note-status" v-model="isActive">
        <span></span>
      </label>
    </section>
    <nav>
      <input v-if="!isSaving" type="button" value="salvar nota" @click="updateNote()" :disabled="!payload.title || !payload.event_date">
      <SpinnerLoaderButton v-else :height="60" :maxWidth="464" />
      <input type="button" value="cancelar" @click="$router.go(-1)">
    </nav>
    <MyModal :width="'341px !important'" :height="'517px !important'" :className="'date-limit'" :isOpen="isEventDateModalOpen" :toggleModal="(v: boolean) => isEventDateModalOpen = v" :zIndex="100">
      <div class="modal-date-title">
        <h1>Data para alerta</h1>
        <h2>Quando você quer ser alertado sobre essa nota?</h2>
      </div>
      <MyDatePicker :key="eventDatePickerKey" :min="{ day: 1, month: 1, year: 2000 }" :name="'event_date'" :initialDate="payload.event_date" :setValue="(date) => selectedEventDate = date" />
      <input type="button" value="Aplicar data" @click="payload.event_date = selectedEventDate; isEventDateModalOpen = false">
    </MyModal>
  </div>
  <SpinnerLoader v-else />
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useAxios } from '@/api/axios'
import { toast } from 'vue3-toastify'
import { AxiosResponse } from 'axios'
import NoteModel from '@/models/NoteModel'
import NoteStatusEnum from '@/enums/NoteStatusEnum'
import PaginationModel from '@/models/PaginationModel'
import MyModal from '@/components/modal/MyModal.vue'
import MyDatePicker from '@/components/date/MyDatePicker.vue'
import MyOptions from '@/components/options/MyOptions.vue'
import TextEditor from '@/components/input/TextEditor.vue'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'
import { hasAiModule } from '@/global/states/GlobalState'

interface DocumentOption {
  id: number
  number: number
  title: string
}

const props = defineProps<{ id: number }>()
const axios = useAxios()

const payload = ref<Partial<NoteModel>>({})
const isActive = ref(true)
const selectedEventDate = ref('')
const isEventDateModalOpen = ref(false)
const eventDatePickerKey = ref(0)

/* AI SUMMARIZATION */
const isSummarizingNote = ref(false)
const noteSummary = ref('')

function summarizeNote (): void {
  if (!payload.value.description || isSummarizingNote.value) return

  isSummarizingNote.value = true

  const body = new FormData()
  body.append('content', payload.value.description)

  axios.post('/api/ai/summarize-content', body)
    .then((res) => {
      noteSummary.value = res.data.summary
    })
    .catch((error) => {
      if (!error?.response?.data?.errors) {
        toast.error('Não foi possível gerar o resumo com IA. Tente novamente.')
      }
    })
    .finally(() => {
      isSummarizingNote.value = false
    })
}
/* AI SUMMARIZATION */

function openDateModal () {
  eventDatePickerKey.value++
  isEventDateModalOpen.value = true
}
const isSaving = ref(false)

const documents = ref<PaginationModel<DocumentOption> | null>(null)
const selectedDocuments = ref<DocumentOption[]>([])
const docSearch = ref('')
const isLoadingDocs = ref(false)

const formattedEventDate = computed(() => payload.value.event_date ? formatDate(payload.value.event_date) : undefined)

function formatDate (date: string): string {
  const [year, month, day] = date.split('-')
  return `${day}/${month}/${year}`
}

function toggleDocument (doc: DocumentOption, checked: boolean): void {
  if (checked) {
    if (!selectedDocuments.value.some(d => d.id === doc.id)) {
      selectedDocuments.value.push(doc)
    }
  } else {
    selectedDocuments.value = selectedDocuments.value.filter(d => d.id !== doc.id)
  }
}

function getDocuments (page: number = 1): void {
  isLoadingDocs.value = true
  axios.get('/api/documents', { params: { per_page: 10, compact: true, page, search: docSearch.value || undefined } })
    .then((res: AxiosResponse<PaginationModel<DocumentOption>>) => {
      documents.value = res.data
    })
    .finally(() => { isLoadingDocs.value = false })
}

function updateNote (): void {
  isSaving.value = true
  axios.patch(`/api/notes/${props.id}`, {
    title: payload.value.title,
    description: payload.value.description ?? null,
    event_date: payload.value.event_date,
    document_ids: selectedDocuments.value.map(d => d.id),
    status: isActive.value ? NoteStatusEnum.ACTIVE : NoteStatusEnum.INACTIVE,
  })
    .then(() => {
      toast.success('Nota editada com sucesso')
    })
    .finally(() => isSaving.value = false)
}

function getNote (): void {
  axios.get(`/api/notes/${props.id}`)
    .then((res: AxiosResponse<NoteModel>) => {
      const note = res.data
      payload.value = { ...note }
      isActive.value = note.status === NoteStatusEnum.ACTIVE
      if (note.documents?.length) {
        selectedDocuments.value = note.documents.map(d => ({ id: d.id, number: d.number, title: d.title }))
      }
    })
}

onMounted(() => {
  getDocuments()
  getNote()
})
</script>

<style lang="scss">
  #edit-notes {
    width: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: start;
    row-gap: 28px;
    padding: 32px 0 0 0;

    section {
      width: 100%;
      display: flex;
      flex-direction: column;
      position: relative;

      &.quantity input {
        padding: 15px 80px 15px 20px !important;
      }

      .date-picker-label {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        input {
          display: flex;
          cursor: pointer;
          color: $fluxoo-primary-color;
        }
        svg {
          width: 24px;
          min-width: 24px;
          height: 24px;
          min-height: 24px;
          stroke: #090909;
          position: absolute;
          right: 22px;
        }
      }

      h1 {
        color: #090909;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        font-weight: 400;
        line-height: normal;
        margin: 0 0 13px 0;
        text-align: start;
        strong {
          color: #090909;
          font-family: 'Inter', sans-serif;
          font-size: 20px;
          font-weight: 700;
          line-height: normal;
        }
      }

      h2 {
        color: #6F6F6F;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        font-weight: 400;
        line-height: normal;
        text-align: start;
        margin: -13px 0 13px 0;
      }

      input[type='text'] {
        width: 100%;
        height: 55px;
        border-radius: 14px;
        border: 1px solid #D3D3D3;
        color: $fluxoo-primary-color;
        font-family: 'Inter', sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: normal;
        padding: 15px 20px;
        box-sizing: border-box;
        transition: border-color .2s, color .2s, background .2s;
        &:focus { outline: none; }
        &::placeholder {
          color: #090909;
          font-family: 'Inter', sans-serif;
          font-size: 16px;
          font-weight: 400;
          transition: color .2s;
        }
      }

      textarea {
        width: 100%;
        height: 127px;
        border-radius: 14px;
        border: 1px solid #D3D3D3;
        color: $fluxoo-primary-color;
        font-family: 'Inter', sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: normal;
        padding: 15px 20px;
        box-sizing: border-box;
        resize: none;
        transition: border-color .2s, color .2s, background .2s;
        &:focus {
          outline: none;
          border: 2px solid $fluxoo-primary-color;
          padding: 14px 19px;
          &::placeholder { color: transparent; }
        }
        &::placeholder {
          color: #090909;
          font-family: 'Inter', sans-serif;
          font-size: 16px;
          font-weight: 400;
          transition: color .2s;
        }
        &::-webkit-scrollbar { width: 0; }
      }

      & > p {
        color: #090909;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        font-weight: 400;
        line-height: normal;
        margin: 0;
        position: absolute;
        top: 57px;
        right: 20px;
      }

      .status-toggle {
        width: 105px;
        display: flex;
        align-items: center;
        column-gap: 10px;
        cursor: pointer;
        input[type='checkbox'] {
          display: none;
          &:checked ~ span {
            background: $fluxoo-primary-color-hover;
            &::before {
              background: $fluxoo-primary-color;
              left: calc(100% - 25px);
            }
            &::after {
              content: 'Ativo';
              color: $fluxoo-primary-color;
            }
          }
        }
        span {
          width: 43px;
          height: 11px;
          background: #949494;
          border-radius: 12px;
          position: relative;
          transition: background .2s;
          &::before {
            content: '';
            width: 25px;
            height: 25px;
            background: #D5D5D5;
            border-radius: 50%;
            position: absolute;
            top: -7px;
            left: 0;
            transition: background .2s, left .2s;
          }
          &::after {
            content: 'Inativo';
            position: absolute;
            left: calc(100% + 10px);
            bottom: -4px;
            color: #949494;
            font-family: 'Inter', sans-serif;
            font-size: 16px;
            font-weight: 400;
            transition: color .2s;
          }
        }
      }
    }

    nav {
      width: 100%;
      max-width: 1200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px 32px;
      border-radius: 16px;
      background: #FFF;
      box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.12);
      box-sizing: border-box;
      position: sticky;
      bottom: 5px;
      column-gap: 20px;
      margin: auto 0 0 0;

      input {
        border: none;
        cursor: pointer;
        &:first-child {
          width: 100%;
          max-width: 464px;
          height: 60px;
          border-radius: 30px;
          background: $fluxoo-primary-color;
          color: #FFF;
          text-align: center;
          font-family: 'Inter', sans-serif;
          font-size: 16px;
          font-weight: 600;
          transition: background .2s;
          &:hover { background: $fluxoo-primary-color-hover; }
          &:disabled {
            background: #F1F1F1;
            color: #6F6F6F;
            cursor: not-allowed;
          }
        }
        &:last-child {
          color: #737373;
          font-family: 'Inter', sans-serif;
          font-size: 16px;
          font-weight: 600;
          background: unset;
          transition: color .2s;
          &:hover { color: $fluxoo-primary-color; }
        }
      }
    }

    .option {
      .doc-search-wrapper {
        width: 100%;
        flex-basis: 100%;
        position: relative;
        display: flex;
        align-items: center;
        input {
          width: 100%;
          height: 40px;
          border-radius: 10px;
          border: 1px solid #D3D3D3;
          background: #F5F5F5;
          color: $fluxoo-primary-color;
          font-family: 'Inter', sans-serif;
          font-size: 14px;
          font-weight: 400;
          padding: 8px 36px 8px 12px;
          box-sizing: border-box;
          transition: border-color .2s;
          &:focus {
            outline: none;
            border-color: $fluxoo-primary-color;
          }
          &::placeholder {
            color: #6F6F6F;
            font-size: 13px;
          }
        }
        svg {
          position: absolute;
          right: 10px;
          stroke: #090909;
          cursor: pointer;
        }
      }
      .doc-skeleton {
        flex: 0 0 100%;
        height: 56px;
        border-radius: 30px;
        background: linear-gradient(90deg, #f0f0f0 25%, #e4e4e4 50%, #f0f0f0 75%);
        background-size: 300% 100%;
        animation: doc-shimmer 1.4s ease-in-out infinite;
        &:nth-child(2) { animation-delay: 0.1s; }
        &:nth-child(3) { animation-delay: 0.2s; }
        &:nth-child(4) { animation-delay: 0.3s; }
        &:nth-child(5) { animation-delay: 0.4s; }
        &:nth-child(6) { animation-delay: 0.5s; }
      }
      .doc-empty {
        width: 100%;
        flex-basis: 100%;
        text-align: center;
        color: #6F6F6F;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        font-weight: 400;
        margin: 4px 0;
        position: static !important;
      }
      .doc-pagination {
        width: 100%;
        flex-basis: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 6px;
        margin: 4px 0 0 0;
        button {
          min-width: 36px;
          height: 36px;
          border-radius: 8px;
          border: 1px solid #D3D3D3;
          background: #FFF;
          color: #090909;
          font-family: 'Inter', sans-serif;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          padding: 0 8px;
          transition: background .2s, border-color .2s, color .2s;
          &:hover:not(:disabled) {
            border-color: $fluxoo-primary-color;
            color: $fluxoo-primary-color;
          }
          &.active {
            background: $fluxoo-primary-color;
            border-color: $fluxoo-primary-color;
            color: #FFF;
          }
          &.passers {
            font-size: 16px;
            font-weight: 400;
          }
          &:disabled {
            opacity: 0.4;
            cursor: not-allowed;
          }
        }
      }
    }

    .modal {
      &.date-limit {
        .modal__content {
          padding: 15px 28px;
          box-sizing: border-box;
          overflow-y: auto;
          &::-webkit-scrollbar { width: 0; }
          button { display: flex; top: 26px; right: 28px; }
          .modal-date-title {
            padding: 0;
            display: flex;
            flex-direction: column;
            align-items: start;
            margin: 0 0 25px 0;
            h1 {
              color: #090909;
              font-family: 'Nunito', sans-serif;
              font-size: 32px;
              font-weight: 800;
              text-align: start;
              margin: 0;
            }
            h2 {
              color: #6F6F6F;
              font-family: 'Inter', sans-serif;
              font-size: 14px;
              font-weight: 400;
              line-height: normal;
              text-align: start;
              margin: 0;
            }
          }
          input[type='button'] {
            width: 100%;
            min-height: 55px;
            border-radius: 30px;
            border: none;
            background: $fluxoo-primary-color;
            color: #FFF;
            text-align: center;
            font-family: 'Inter', sans-serif;
            font-size: 16px;
            font-weight: 600;
            margin: 8px 0 0 0;
            transition: background .2s;
            cursor: pointer;
            &:hover { background: $fluxoo-primary-color-hover; }
          }
        }
      }
    }
  }

  @keyframes doc-shimmer {
    0%   { background-position: 100% 0; }
    100% { background-position: -100% 0; }
  }

  @media(max-width: 425px) {
    #edit-notes {
      padding: 25px 0 120px 0;
      nav {
        animation: enterToBottom ease 0.9s;
        width: 100vw;
        position: fixed;
        left: 0;
        bottom: 0;
        border-radius: 20px 20px 0px 0px;
        background: #FFF;
        box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.12);
        padding: 15px;
        box-sizing: border-box;
        z-index: 4;
      }
      .modal {
        padding: unset;
        &.date-limit {
          padding: 0 10px;
          .modal__content {
            border-radius: 28px;
            padding: 15px;
          }
        }
      }
    }
  }
</style>
